module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Minus-91356f49113c683dfbb60397a2ebb7c3.svg";